import { IAuthService } from "../IAuthService";
import { LogonResp } from "../../model/core/LogonResp";
import { Subject } from "rxjs";
import { SessionStoreData } from "../../model/core/SessionStoreData";

export abstract class UserAuthPromiseService implements IAuthService {
  public abstract isResetRequested(): Promise<boolean>;
  public abstract disconnectOnLogout(): Promise<any>;
  public abstract requestLogin(user: any, timeout: number, sso: boolean): Promise<LogonResp>;
  public abstract getTokenEventSubject(): Subject<SessionStoreData>;
  public abstract requestAppRefresh(storeData: SessionStoreData): Promise<any>;
  public abstract getLogoutWarnings(
    isTrader: boolean,
    hasOrdersInDi: boolean,
  ): Promise<Array<string>>;

  public abstract registerHOM(hom: { getStagingOrderCount(): number });
}
